import { Theme } from '@mui/material/styles'

const muiRadio = (theme: Theme) => {
  return {
    variants: [
      {
        props: { size: 'smallest' },
        style: {
          '& .MuiSvgIcon-root ': {
            fontSize: '1rem'
          }
        }
      }
    ],
    defaultProps: {
      disableRipple: true,
      disableFocusRipple: true,
      disableTouchRipple: true
    },
    styleOverrides: {
      root: {
        marginRight: '0.375rem',
        padding: '0.375rem',
        '& .MuiSvgIcon-root ': {
          color: theme.colors.default,
          fontSize: '2rem'
        },
        '&:hover': {
          background: theme.palette.success.light
        },
        '&.Mui-checked': {
          '& .MuiSvgIcon-root ': {
            color: 'inherit'
          }
        },
        '&.Mui-disabled': {
          cursor: 'disabled'
        }
      }
    }
  }
}

export default muiRadio
